// Chord transposition for the inline "[G]" chords in lyrics.

const SHARPS = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
const FLATS = ["C", "Db", "D", "Eb", "E", "F", "Gb", "G", "Ab", "A", "Bb", "B"];
const ROOT = /^([A-G])([#b]?)/;

const indexOf = (root) => {
  const sharp = SHARPS.indexOf(root);
  return sharp >= 0 ? sharp : FLATS.indexOf(root);
};

/** Transposes a note name with an optional suffix ("F#m7" -> "G#m7"); other text is returned as is. */
export function transposeNote(note, semitones, preferFlats = false) {
  const match = ROOT.exec(note || "");
  if (!match || !semitones) return note;
  const index = indexOf(match[1] + match[2]);
  if (index < 0) return note;
  const next = (((index + semitones) % 12) + 12) % 12;
  return (preferFlats ? FLATS : SHARPS)[next] + note.slice(match[0].length);
}

/** Transposes a chord including a slash bass ("D/F#" -> "E/G#"); flats stay flats. */
export function transposeChord(chord, semitones) {
  if (!semitones || !chord) return chord;
  const preferFlats = /^[A-G]b/.test(chord);
  return chord
    .split("/")
    .map((part) => transposeNote(part, semitones, preferFlats))
    .join("/");
}

/** Describes an offset in semitones for display: "+2", "-3" or "" for none. */
export const describeTranspose = (semitones) => (semitones > 0 ? `+${semitones}` : semitones < 0 ? `${semitones}` : "");
